import { motion } from "framer-motion";

const EnergyFlowSVG = ({ className = "" }) => (
  <svg viewBox="0 0 800 200" className={`w-full ${className}`} preserveAspectRatio="none">
    <defs>
      <linearGradient id="flowGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="hsl(155 80% 50%)" stopOpacity="0" />
        <stop offset="50%" stopColor="hsl(155 80% 50%)" stopOpacity="0.6" />
        <stop offset="100%" stopColor="hsl(210 80% 55%)" stopOpacity="0" />
      </linearGradient>
      <filter id="glow">
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    {[0, 1, 2].map((i) => (
      <motion.path
        key={i}
        d={`M0,${80 + i * 30} Q200,${50 + i * 20} 400,${100 + i * 10} T800,${70 + i * 25}`}
        fill="none"
        stroke="url(#flowGrad)"
        strokeWidth="1.5"
        filter="url(#glow)"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 2 + i * 0.5, delay: i * 0.3, ease: "easeInOut" }}
      />
    ))}
    {[100, 300, 500, 700].map((x, i) => (
      <motion.circle
        key={i}
        cx={x}
        cy={80 + (i % 3) * 15}
        r="3"
        fill="hsl(155 80% 50%)"
        filter="url(#glow)"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: [0, 1, 0], scale: [0, 1.5, 0] }}
        transition={{ duration: 2, delay: i * 0.5, repeat: Infinity }}
      />
    ))}
  </svg>
);

export default EnergyFlowSVG;
